module.exports = __webpack_public_path__ + "static/gh-4-a3af983535157787f211ca83223589de.jpg";